module.exports = __webpack_public_path__ + "img/V-R-4-unload-standup-shadow.7e0c144c.png";